import { Loader2 } from 'lucide-react';

type ModalFooterProps = {
  step: 'bank' | 'amount';
  adding: boolean;
  hasBanks: boolean;
  formId: string;
  isAddingBank: boolean;
  isWithdrawing: boolean;
  onBack: () => void;
  onCancel: () => void;
  onContinueWithBank: () => void;
  onSubmitWithdraw: () => void;
};

export function ModalFooter({
  step,
  adding,
  hasBanks,
  formId,
  isAddingBank,
  isWithdrawing,
  onBack,
  onCancel,
  onContinueWithBank,
  onSubmitWithdraw,
}: ModalFooterProps) {
  const showBack = step === 'amount' || (step === 'bank' && adding && hasBanks);

  return (
    <div className="flex gap-2 border-t border-[var(--dash-line)] px-5 py-4">
      <button
        type="button"
        onClick={showBack ? onBack : onCancel}
        className="flex-1 rounded-lg border border-[var(--dash-line)] py-2.5 text-sm font-semibold text-[var(--dash-ink)] hover:bg-[var(--dash-soft)]"
      >
        {showBack ? 'Back' : 'Cancel'}
      </button>

      {step === 'bank' && adding ? (
        <button
          type="submit"
          form={formId}
          disabled={isAddingBank}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-semibold text-white disabled:opacity-50"
          style={{ background: 'var(--dash-brand, #003481)' }}
        >
          {isAddingBank ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Save & continue
        </button>
      ) : step === 'bank' ? (
        <button
          type="button"
          onClick={onContinueWithBank}
          className="flex-1 rounded-lg py-2.5 text-sm font-semibold text-white"
          style={{ background: 'var(--dash-brand, #003481)' }}
        >
          Continue
        </button>
      ) : (
        <button
          type="button"
          disabled={isWithdrawing}
          onClick={onSubmitWithdraw}
          className="flex flex-1 items-center justify-center gap-2 rounded-lg py-2.5 text-sm font-semibold text-white disabled:opacity-50"
          style={{ background: 'var(--dash-brand, #003481)' }}
        >
          {isWithdrawing ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          Submit request
        </button>
      )}
    </div>
  );
}
